// Web_Promo URL parameter — referral-email deep link support.
//
// The updated referral invitation email's CTA links to the booking page
// with the referrer's promo code in the URL:
//   https://clubchampion.com/?Web_Promo=RCUS611804&utm_source=ccg&...
//
// When present, the widget pre-validates the code at invocation and, if
// SF accepts it, seeds the promo field in the validated state so the
// visitor arrives at the booking panel with the referral promo already
// applied. Schedule behavior is unchanged: the code rides alongside the
// house default exactly like a hand-typed validated code
// (`CUSTOMFIT;<code>` via buildPromoCodeForSchedule).
//
// Verified 2026-08-03: referral codes validate without an email, so
// mount-time prevalidation (before Step 1 captures the email) is sound.

/** Read the Web_Promo parameter from the embedding page URL (key match is
 *  case-insensitive; returns null when absent or blank). */
export function getWebPromoCode(): string | null {
  if (typeof location === 'undefined') return null;
  const params = new URLSearchParams(location.search);
  for (const [k, v] of params) {
    if (k.toLowerCase() === 'web_promo' && v.trim()) return v.trim();
  }
  return null;
}
